import { render, staticRenderFns } from "./ColoredSpace.vue?vue&type=template&id=6aa10263&"
import script from "./ColoredSpace.vue?vue&type=script&lang=js&"
export * from "./ColoredSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports